import { IconButton } from "@mui/material"
import { FC, ReactNode } from "react"
interface SquareIconProps {
  children: ReactNode
  color?:
    | "inherit"
    | "default"
    | "primary"
    | "secondary"
    | "error"
    | "info"
    | "success"
    | "warning"
  borderColor?: string
  backgroundColor?: string
  disabled?: boolean
}

export const SquareIcon: FC<SquareIconProps> = ({
  children,
  color = "primary",
  borderColor = color,
  backgroundColor = "transparent",
  disabled = false,
}) => {
  return (
    <IconButton
      color={color}
      size="small"
      sx={{
        color: color,
        border: "1.6px solid",
        borderRadius: 1,
        borderColor: borderColor,
        backgroundColor: backgroundColor,
      }}
      disabled={disabled}
    >
      {children}
    </IconButton>
  )
}
